import { render } from "./PollyPricerView.vue?vue&type=template&id=5438e18e&scoped=true"
import script from "./PollyPricerView.vue?vue&type=script&lang=js"
export * from "./PollyPricerView.vue?vue&type=script&lang=js"

import "./PollyPricerView.vue?vue&type=style&index=0&id=5438e18e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5438e18e"]])

export default __exports__